<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="!details"></loading>
	
	
	<table *ngIf="details && details.length > 0" class="table">
		<thead>
			<th>{{ 'adminstat.billing.domain_zones.transaction_date' | translate }}</th>
			<th>{{ 'adminstat.common.Domain' | translate }}</th>
			<th>{{ 'adminstat.common.Site' | translate }}</th>
			<th>{{ 'adminstat.common.User' | translate }}</th>
			<th>{{ 'adminstat.common.Status' | translate }}</th>
		</thead>
		
		<tbody>
			<tr *ngFor="let stat of details">
				<td>{{ stat.time }}</td>
				<td>
					<a rel="noreferrer" [href]="'http://' + stat.domain">{{ stat.domain }}</a>
				</td>
				<td>
					<site_info [siteUrl]="stat.site"></site_info>
				</td>
				<td><gotosupport [value]="stat.email"></gotosupport></td>
				<td>{{ stat.status }}</td>
			</tr>
		</tbody>
	</table>
</info-modal>
